module.exports = __webpack_public_path__ + "media/images/icons/address-751e488751afeec5ffed3f6ec42bff1a.svg";